import { render } from "./CompanyEdit.vue?vue&type=template&id=315206e0&ts=true"
import script from "./CompanyEdit.vue?vue&type=script&lang=ts"
export * from "./CompanyEdit.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__